import React from 'react'
import './Accrediations.scss'
export const Accrediations = () => {
    return (
        <>
            <section className="page-header association-banner member-section">
                <video controls autoPlay loop muted>
                <source src="https://www.oneworldnetwork.co/video/1wn-association-video.mp4" type="video/mp4" />

                </video>

                <div className="page-header__bg pioneering post-event-gallery-banner">
                </div>
                <div className="page-header__inner">
                    <h2>Pioneering <br />the Future of Global Freight</h2>
                    <div className="thm-breadcrumb__box">
                        <ul className="thm-breadcrumb list-unstyled">
                     
                        </ul>
                    </div>
                </div>
            </section>
            {/* //   <!--Page Header End--> */}
            <div className="container heading-previous-event"><div className="row"><div className="col-lg-12"><h2 className='section-title__title'>Associations & Accreditations</h2></div></div></div>
            <div className="rounded-div">
                {/* <div className='container'> */}
                <div className='container vertical-md vertical-md-sec'>
                    <div className='row'>
                        <div className='col-lg-7'>
                            <div className='vertical-img-sec p-2'><img src="/images/mission-vision/tiaca.png" /></div>
                        </div>
                        <div className='col-lg-5  text-content p-0'>
                            <h2>TIACA</h2>
                            <p> As a proud member of The International Air Cargo Association (TIACA), 1WN champions global standards in air cargo, driving innovation, collaboration, and advocacy across the entire supply chain. </p>
                        </div>
                    </div>
                </div>

                <div className='container vertical-md'>
                    <div className='row'>
                        <div className='col-lg-5 text-content p-0'>
                            <h2>FIATA</h2>
                            <p>As a member of FIATA, 1WN connects with a global network committed to advancing excellence in freight forwarding—promoting seamless operations, best practices, and unified industry standards.</p>
                        </div>
                        <div className='col-lg-7 vertical-right'>
                            <div className='vertical-img-sec p-2'><img src="/images/mission-vision/fiata-logo.png" /></div>
                        </div>
                    </div>
                </div>

                <div className='container vertical-md vertical-md-sec'>
                    <div className='row'>
                        <div className='col-lg-7'>
                            <div className='vertical-img-sec p-2'><img src="/images/mission-vision/accai.png" /></div>
                        </div>
                        <div className='col-lg-5 text-content p-0'>
                            <h2>ACCAI</h2>
                            <p>In alignment with ACCAI, 1WN is dedicated to championing the freight industry's interests—delivering safe, reliable, and future-ready logistics solutions across air cargo and the broader supply chain.</p>
                        </div>
                    </div>
                </div>

                <div className='container vertical-md'>
                    <div className='row'>
                        <div className='col-lg-5 text-content p-0'>
                            <h2>EU Chamber</h2>
                            <p>1WN is proud to collaborate with the EU Chamber, advancing European logistics standards and forging strategic partnerships that elevate global supply chain excellence.</p>
                        </div>
                        <div className='col-lg-7 vertical-right'>
                            <div className='vertical-img-sec p-2 py-4'><img src="/images/mission-vision/eu-india-chamber.jpg" /></div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}
